import type { ExpenseGroup, FinanceSection } from './catalog'
import { FINANCE_CATALOG } from './catalog'

// Couleur stable par catégorie financière, ancrée sur les tokens
// `--chart-cat-1…8` (globals.css). Client-safe : aucun import firestore.
//
// Revenus : une teinte par département (ordre = catalogue).
// Dépenses : une teinte par GROUPE (cogs / indirect_cogs / opex / other), car le
// modèle détaillé compte ~23 lignes — les colorer une à une serait illisible.
// Les cartes de répartition reçoivent des lignes déjà agrégées par groupe
// (cf. groupExpenseLines), dont le `code` est la clé de groupe.

const REVENUE_ORDER = ['TCP', 'LCT', 'RENTAL', 'SALES', 'TMP', 'OTHER']
const EXPENSE_GROUP_ORDER: ExpenseGroup[] = ['cogs', 'indirect_cogs', 'opex', 'other']

// code dépense → groupe (pour colorer aussi une ligne brute non agrégée).
const CODE_TO_GROUP = new Map(
  FINANCE_CATALOG.filter((e) => e.section === 'expense' && e.group).map((e) => [
    e.code,
    e.group as ExpenseGroup,
  ]),
)

const FALLBACK = 'var(--chart-cat-8)'

export function categoryColor(section: FinanceSection, code: string): string {
  if (section === 'revenue') {
    const idx = REVENUE_ORDER.indexOf(code)
    return idx === -1 ? FALLBACK : `var(--chart-cat-${idx + 1})`
  }
  // Dépense : `code` est soit une clé de groupe, soit un code de ligne.
  const group = (EXPENSE_GROUP_ORDER as string[]).includes(code)
    ? (code as ExpenseGroup)
    : CODE_TO_GROUP.get(code)
  const idx = group ? EXPENSE_GROUP_ORDER.indexOf(group) : -1
  return idx === -1 ? FALLBACK : `var(--chart-cat-${idx + 1})`
}
